import { daysInStage } from './format.js';

const TERMINAL_STAGES = new Set(['HIRED', 'REJECTED']);

export function getApplicantProductivityFlags(applicant = {}) {
  const stageAgeDays = daysInStage(applicant.updated_at);
  const isStale = stageAgeDays >= 14 && !TERMINAL_STAGES.has(applicant.stage);
  const contactBlockedLabel = applicant.do_not_contact
    ? 'Do not contact'
    : applicant.consent_status === 'opted_out'
      ? 'Opted out'
      : !hasUsablePhone(applicant.phone)
        ? 'Missing phone'
        : '';

  return {
    stageAgeDays,
    isStale,
    staleLabel: isStale ? `${stageAgeDays}d in stage` : '',
    contactBlockedLabel,
  };
}

function hasUsablePhone(value) {
  if (typeof value !== 'string') return false;
  const digits = value.replace(/\D/g, '');
  return digits.length >= 10;
}

export function isApplicantSelectableForBulkMessage(applicant = {}) {
  return hasUsablePhone(applicant.phone) && !applicant.do_not_contact && applicant.consent_status !== 'opted_out';
}

export function getBulkSelectionSummary(selectedApplicants = []) {
  const contactableIds = selectedApplicants
    .filter(isApplicantSelectableForBulkMessage)
    .map(applicant => applicant.id);

  return {
    selectedCount: selectedApplicants.length,
    contactableCount: contactableIds.length,
    skippedCount: selectedApplicants.length - contactableIds.length,
    contactableIds,
  };
}
